/*
 * action types
 */
export const MATERIAL_DOCUMENT_LIST = 'MATERIAL_DOCUMENT_LIST'
export const MATERIAL_DOCUMENT_ID = 'MATERIAL_DOCUMENT_ID'

/*
 * action creators
 */
export function materialDocumentList(payload) {
  return { payload, type: MATERIAL_DOCUMENT_LIST }
}
export function materialDocumentId(payload) {
  return { payload, type: MATERIAL_DOCUMENT_ID }
}
